/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { SuggestedUtteranceStore } from 'src/luis/projects/utterances/stores/suggestedUtteranceStore';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { SuggestedUtteranceStoreHouse } from 'src/luis/types/stores/utterances/SuggestedUtteranceStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating an intent store house,
 * which houses an array of intent stores.
 */
export const createSuggestedUtteranceStoreHouse = (): SuggestedUtteranceStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<SuggestedUtteranceStore>();
    const suggestedUtteranceStoreHouse: SubtractStore<SuggestedUtteranceStoreHouse, ResourceStoreHouse<SuggestedUtteranceStore>> = {};

    return extendObservable(resourcesStoreHouse, suggestedUtteranceStoreHouse, {}, { deep: false });
};
